import { values } from 'lodash';
import { useTranslation } from 'react-i18next';
import { sortNamesBy } from 'logic/sortNames';
import { Theme, DeviceType, ThemeId } from 'shared/models';
import { UpdateThemeCommand } from 'logic/deviceScriptParser';

export type Props = {
    command: UpdateThemeCommand;
    themes: Record<ThemeId, Theme>;
    deviceType: DeviceType | null;
    onClickTheme(themeId: string): void;
};

export const UpdateThemeCommandOptions = ({ command, themes, deviceType, onClickTheme }: Props) => {
    const { t } = useTranslation();
    const { id, displayName } = themes[command.themeId] || {};
    return (
        <span className="update-theme-command-options">
            <span className="ui compact menu">
                <div className="ui simple dropdown item">
                    { displayName || id ||
                        <span style={ { opacity: .5 } }>
                            { t('DEVICE.COMMANDS.NONE_SELECTED') }
                        </span>
                    }
                    <i className="dropdown icon"/>
                    <div className="menu">
                        { getEligibleThemes(themes, deviceType).map(t =>
                            <div
                                key={ t.id }
                                className="item"
                                onClick={ () => onClickTheme(t.id) }
                            >
                                { t.displayName || t.id }
                            </div>
                        ) }
                    </div>
                </div>
            </span>
        </span>
    );
};

function getEligibleThemes(themes: Record<ThemeId, Theme>, deviceType: DeviceType | null): Theme[] {
    if (!themes || !deviceType) return [];
    const { pixelWidth, pixelHeight } = deviceType;
    return values(themes)
        .filter(t =>
            // Only show themes that match the same size (or rotated size)
            (t.width === pixelWidth && t.height === pixelHeight) ||
            (t.width === pixelHeight && t.height === pixelWidth)
        )
        .filter(t =>
            // Only show themes that are appropriate for the device type
            (t.requirements.TTG && deviceType.deviceCapabilities.TTG) ||
            (t.requirements.Matisse && deviceType.deviceCapabilities.Matisse)
        )
        .sort(sortNamesBy(t => t.displayName || t.id));
}
